export default __webpack_public_path__ + "static/media/demoInvestment.6646b25a.svg";